import React from 'react';

export interface Sign7IconProps {}

export const Sign7Icon: React.FC<Sign7IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 18.5L17.686 9.6015C17.6598 9.42457 17.5412 9.27506 17.3748 9.20943C17.1363 9.11533 16.8689 9.21733 16.7507 9.43805L16.7262 9.49106L15.2445 13.2479L6.39932 5.55887L4.43114 7.823L13.2763 15.5121L9.76229 17.5021C9.62612 17.5793 9.53507 17.7149 9.5136 17.8674L9.50873 17.9337C9.50694 18.1901 9.69848 18.4028 9.94694 18.4334L10.0052 18.4372L19 18.5Z"
        fill="#192033"
      />
    </svg>
  );
};
